import { mapActions, mapGetters } from 'vuex';

import { APP_CONSTS } from '../store/app/app.consts';

export const SteppedAnimationMixin = {
  computed: {
    ...mapGetters(APP_CONSTS.moduleName, {
      playedAnimations: APP_CONSTS.getters.playedAnimations
    }),
    alreadyPlayedAnimation: function (): boolean {
      return (this.playAnimationOnce && this.playedAnimations.includes(this.animationId));
    }
  },
  data: function () {
    return {
      animationId: undefined,
      playAnimationOnStart: true,
      playAnimationOnce: false,
      currentAnimationStep: undefined,
      animationStepDurationsInMillis: [1000, 1000, 1000],
      animationStepTimeout: undefined
    };
  },
  methods: {
    ...mapActions(APP_CONSTS.moduleName, {
      addPlayedAnimation: APP_CONSTS.actions.addPlayedAnimation
    }),
    onAnimationFinished: function (): void {}
  },
  created: function (): void {
    if (!this.animationId) {
      this.animationId = this.$options.name;
    }
  },
  mounted: function (): void {
    if (this.playAnimationOnStart) {
      this.currentAnimationStep = 0;
    }
    if (this.alreadyPlayedAnimation) {
      this.currentAnimationStep = this.animationStepDurationsInMillis.length - 1;
    }
  },
  watch: {
    currentAnimationStep: function (): void {
      if (!this.alreadyPlayedAnimation) {
        clearTimeout(this.animationStepTimeout);
        this.animationStepTimeout = setTimeout(() => {
          if (this.currentAnimationStep < this.animationStepDurationsInMillis.length - 1) {
            this.currentAnimationStep++;
          } else {
            this.addPlayedAnimation(this.animationId);
            this.onAnimationFinished();
          }
        }, this.animationStepDurationsInMillis[this.currentAnimationStep]);
      }
    }
  }
};
